module.exports = __webpack_public_path__ + "img/Afar_Certificate.2a63a92d.jpg";